<template>
	<div>
		<iframe title="manual" :src="parametrosSistema.urlManualize"></iframe>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	computed: {
		...mapState({
			parametrosSistema: (state) => state.parametrosSistema,
		}),
	},
}
</script>

<style scoped lang="stylus">
iframe
	border 0px
	margin-left 0px
	height 1100px
	margin-top 0px
	width 100%
</style>
